var _defs, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelephoneBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_6",
    "data-name": "Calque 6",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 245 501.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#272b2e;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "t\xE9l\xE9phone") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 245,
    height: 501.04,
    rx: 48.11
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 11.04,
    y: 9.56,
    width: 222.93,
    height: 481.91,
    rx: 48.11
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 78.72,
    y: 2.21,
    width: 87.55,
    height: 15.45,
    rx: 7.73
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephoneBg);
export default __webpack_public_path__ + "static/media/telephone_bg.4e789c1db7904ed2d4c8d508e039eabe.svg";
export { ForwardRef as ReactComponent };